
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import Services from './components/Services';
import Process from './components/Process';
import PricingPreview from './components/PricingPreview';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <Process />
      <PricingPreview />
      <FAQ />
      <FinalCTA />
      <Footer />
    </div>
  );
}
